import { isServerSide } from "@jti/fe-common";
import { getAddressByIp, getUser } from "@jti/rest-api";
export const templatesNames = [
    "account-information",
    "account-page",
    "account-ploom-club",
    "cart",
    "checkout",
    "communication-preferences",
    "contact-page",
    "faq-page",
    "flavor-finder",
    "free-trial-checkout",
    "free-trial-landing-page",
    "free-trial-PDP",
    "home-page",
    "login-page",
    "my-addresses",
    "my-devices",
    "my-orders",
    "my-subscription",
    "order-confirmation",
    "other",
    "get-started",
    "ploom-club-article",
    "ploom-club-blog",
    "ploom-club-overview",
    "ploom-club-pack-codes",
    "ploom-club-points-history",
    "ploom-club-redeem",
    "ploom-design-house",
    "ploom-hav-page",
    "product-details-page",
    "product-marketing-page",
    "referral-page",
    "search-results",
    "shop",
    "signup_regular",
    "store-locator",
    "unsubscribe",
    "blog",
    "article-page",
];
const namesMapping = {
    homepage: "home-page",
};
const isValidateTemplateName = (name) => templatesNames.includes(name);
const validateTemplateName = (name) => {
    if (!name) {
        return "other";
    }
    return isValidateTemplateName(name) ? name : namesMapping[name] || "other";
};
export class GoogleTagManagerEvents {
    constructor(name, callback, points, referee) {
        var _a, _b;
        this.gtmContainer = null;
        if (!isServerSide()) {
            this.gtmContainer = document.getElementById("gtmContainer");
            this.pageLang = (_b = (_a = document.querySelector("html")) === null || _a === void 0 ? void 0 : _a.getAttribute("lang")) !== null && _b !== void 0 ? _b : "";
        }
        this.templateName = validateTemplateName(name);
        this.country = "";
        this.user = getUser();
        this.userPoints = points;
        this.referee = referee;
        this.callbackRun = false;
        this.user_membership = "N/A";
        const runCallback = () => {
            if (!this.callbackRun) {
                callback();
                this.callbackRun = true;
            }
        };
        if (!isServerSide() && this.gtmContainer) {
            const gtmContainerObserver = new MutationObserver(() => this.updateTemplateName());
            gtmContainerObserver.observe(this.gtmContainer, { attributes: true });
        }
        getAddressByIp()
            .then((response) => {
            var _a;
            this.country = ((_a = response === null || response === void 0 ? void 0 : response.countryRegion) === null || _a === void 0 ? void 0 : _a.isoCode) || "";
            runCallback();
        })
            .catch(() => runCallback());
    }
    updateTemplateName() {
        var _a;
        this.templateName = validateTemplateName((_a = this.gtmContainer) === null || _a === void 0 ? void 0 : _a.dataset.pageName);
    }
    getStandardData(event) {
        var _a, _b;
        return {
            event,
            section: this.templateName,
            user_id: ((_a = this.user) === null || _a === void 0 ? void 0 : _a.uuid) || undefined,
            user_country: this.country || undefined,
            user_language: this.pageLang || undefined,
            user_points_balance: ((_b = this.user) === null || _b === void 0 ? void 0 : _b.uuid) ? this.userPoints : undefined,
            template_name: this.templateName || undefined,
            referee: this.referee || undefined,
            user_membership: this.user_membership,
        };
    }
}
//# sourceMappingURL=GoogleTagManagerEvents.js.map